import React, { createContext, Dispatch, ReactNode, useContext } from "react";

import { Action } from "./FufAndAttachmentsReducer";

interface FufAndAttachmentsUploadContext {
    dispatch: Dispatch<Action>;
}

interface FufAndAttachmentsUploadProviderProps {
    children: ReactNode;
    dispatch: Dispatch<Action>;
}

const FufAndAttachmentsUploadContext = createContext<FufAndAttachmentsUploadContext | null>(null);

export const FufAndAttachmentsUploadProvider = ({ children, dispatch }: FufAndAttachmentsUploadProviderProps) => (
    <FufAndAttachmentsUploadContext.Provider value={{ dispatch: dispatch }}>
        {children}
    </FufAndAttachmentsUploadContext.Provider>
);

export const useFufAndAttachmentsUpload = () => {
    const context = useContext(FufAndAttachmentsUploadContext);

    if (!context) {
        throw new Error("useFufAndAttachmentsUpload must be used within the context");
    }

    return context;
};
